import { Injectable } from '@angular/core';
import { Store } from '@ngrx/store';
import { IAlarmRegular } from 'src/models/alarm-regular';
import { CognitoService } from '../cognito.service';
import { ServiceBase } from '../service-base';
import axios from 'axios';
import { environment } from 'src/environments/environment';

@Injectable({
  providedIn: 'root',
})
export class AlarmRegularService extends ServiceBase<any> {
  readonly propertyName = 'regular_history';

  constructor(cognito: CognitoService, store: Store) {
    super(cognito, store, 'alarm/regular_history');
  }

  public findAll(params?: { patient_info_id?: string, year?: number, month?: number }): Promise<IAlarmRegular[]> {
    return super.findAll(params);
  }

  async getImage(medicineId: string): Promise<string> {
    return (
      await axios.get<any>(
        environment.api_base_url + `pharmacist/alarm/${medicineId}/image`,
        await this.buildConfig(undefined, 'application/json'),
      )
    ).data.image as string;
  }
}
